import React from 'react';
import { Link } from "react-router-dom";
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { FaInstagram, FaFacebookSquare, FaNewspaper, FaMicrophone, FaArrowRight } from "react-icons/fa";

class AboutPage extends React.Component {
  render() {
    return (
      <div style={{ 
        minHeight: '100vh', 
        background: 'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 50%, #60a5fa 100%)',
        paddingTop: '70px',
        paddingBottom: '70px'
      }}>
        {/* Top Navbar */}
        <Navbar expand="sm" fixed="top" style={{ 
          background: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)',
          boxShadow: '0 2px 20px rgba(0,0,0,0.1)'
        }}>
          <Link to="/" style={{ marginLeft: '1rem' }}>
            <img src="/images/p10.jpg" alt="Logo" style={{ height: '40px',borderRadius: '8px' }} />
          </Link>
          <Nav className="ml-auto" style={{ marginRight: '1rem' }}>
            <Link to="/support" style={{ 
              color: '#1e3a8a', 
              textDecoration: 'none',
              fontWeight: '600',
              marginLeft: '1.5rem'
            }}>
              Support
            </Link>
          </Nav>
        </Navbar>

        {/* Main Content */}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center',
          minHeight: 'calc(100vh - 140px)',
          padding: '40px 20px'
        }}>
          <div style={{ 
            maxWidth: '1000px',
            width: '100%'
          }}>
            {/* Hero Section */}
            <div style={{ 
              textAlign: 'center',
              marginBottom: '3rem',
              color: 'white'
            }}>
              <h1 style={{ 
                fontSize: '3.5rem',
                fontWeight: '700',
                marginBottom: '1rem',
                textShadow: '0 2px 10px rgba(0,0,0,0.2)'
              }}>
                Out of 10?
              </h1>
              <p style={{ 
                fontSize: '1.5rem',
                fontWeight: '600',
                marginBottom: '0.5rem',
                opacity: 0.95
              }}>
                Find Perfect. Be Perfect.
              </p>
              <p style={{ 
                fontSize: '1.3rem',
                opacity: 0.9,
                fontStyle: 'italic'
              }}>
                Find Perfection in the Imperfect.
              </p>
            </div>

            {/* Newsletter Section - Featured */}
            <div style={{
              background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)',
              borderRadius: '20px',
              padding: '2.5rem',
              marginBottom: '2rem',
              boxShadow: '0 15px 50px rgba(0,0,0,0.25)',
              border: '3px solid white',
              transform: 'scale(1.02)',
              position: 'relative',
              overflow: 'hidden'
            }}>
              <div style={{
                position: 'absolute',
                top: '-50px',
                right: '-50px',
                fontSize: '200px',
                opacity: '0.1',
                transform: 'rotate(15deg)'
              }}>
                📧
              </div>
              <div style={{ position: 'relative', zIndex: 1 }}>
                <div style={{ 
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '1rem',
                  marginBottom: '1rem'
                }}>
                  <FaNewspaper style={{ fontSize: '3rem', color: 'white' }} />
                  <h2 style={{ 
                    fontSize: '2.2rem',
                    fontWeight: '700',
                    margin: 0,
                    color: 'white',
                    textShadow: '0 2px 4px rgba(0,0,0,0.2)'
                  }}>
                    The p10 Weekly
                  </h2>
                </div>
                <p style={{ 
                  color: 'white',
                  fontSize: '1.2rem',
                  marginBottom: '1.5rem',
                  textAlign: 'center',
                  fontWeight: '500',
                  textShadow: '0 1px 2px rgba(0,0,0,0.1)'
                }}>
                  The only newsletter that highlights what's truly a 9 or 10—so you never waste a day or meal again.
                </p>
                <div style={{ textAlign: 'center' }}>
                  <a 
                    href="https://p10rating.beehiiv.com/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      background: 'white',
                      color: '#f59e0b',
                      padding: '1rem 2.5rem',
                      borderRadius: '50px',
                      textDecoration: 'none',
                      fontWeight: '700',
                      fontSize: '1.2rem',
                      boxShadow: '0 8px 20px rgba(0,0,0,0.2)',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-3px)';
                      e.currentTarget.style.boxShadow = '0 12px 30px rgba(0,0,0,0.3)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.2)';
                    }}
                  >
                    Subscribe Now <FaArrowRight />
                  </a>
                </div>
              </div>
            </div>

            {/* Interview Section */}
            <div style={{ 
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '1.5rem',
              marginBottom: '2rem'
            }}>
              {/* Canvas Rebel Interview */}
              <a 
                href="https://canvasrebel.com/meet-joe-zamora/" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{
                  textDecoration: 'none',
                  background: 'white',
                  borderRadius: '16px',
                  padding: '2rem',
                  boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer',
                  display: 'block'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-8px)';
                  e.currentTarget.style.boxShadow = '0 15px 50px rgba(0,0,0,0.25)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 10px 40px rgba(0,0,0,0.15)';
                }}
              >
                <div style={{ 
                  fontSize: '2.5rem',
                  color: '#3b82f6',
                  marginBottom: '1rem'
                }}>
                  <FaMicrophone />
                </div>
                <h3 style={{ 
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  marginBottom: '0.5rem',
                  color: '#1e3a8a'
                }}>
                  Canvas Rebel Interview
                </h3>
                <p style={{ 
                  color: '#718096',
                  marginBottom: '1rem',
                  lineHeight: '1.6'
                }}>
                  Learn about the story behind p10 Rating and the vision to help people find perfection.
                </p>
                <span style={{
                  color: '#3b82f6',
                  fontWeight: '600',
                  fontSize: '1rem',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}>
                  Read Interview <FaArrowRight />
                </span>
              </a>

              {/* Voyage Austin Interview */}
              <a 
                href="https://voyageaustin.com/interview/hidden-gems-meet-joe-zamora-of-p10-rating-llc/" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{
                  textDecoration: 'none',
                  background: 'white',
                  borderRadius: '16px',
                  padding: '2rem',
                  boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer',
                  display: 'block'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-8px)';
                  e.currentTarget.style.boxShadow = '0 15px 50px rgba(0,0,0,0.25)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 10px 40px rgba(0,0,0,0.15)';
                }}
              >
                <div style={{ 
                  fontSize: '2.5rem',
                  color: '#60a5fa',
                  marginBottom: '1rem'
                }}>
                  <FaMicrophone />
                </div>
                <h3 style={{ 
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  marginBottom: '0.5rem',
                  color: '#1e3a8a'
                }}>
                  Voyage Austin Feature
                </h3>
                <p style={{ 
                  color: '#718096',
                  marginBottom: '1rem',
                  lineHeight: '1.6'
                }}>
                  Discover the hidden gem of Austin and meet Joe Zamora, founder of p10 Rating LLC.
                </p>
                <span style={{
                  color: '#60a5fa',
                  fontWeight: '600',
                  fontSize: '1rem',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}>
                  Read Interview <FaArrowRight />
                </span>
              </a>
            </div>

            {/* Social Media Section */}
            <div style={{
              background: 'white',
              borderRadius: '16px',
              padding: '2.5rem',
              boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
              textAlign: 'center'
            }}>
              <h2 style={{ 
                fontSize: '2rem',
                fontWeight: '600',
                marginBottom: '1.5rem',
                color: '#1e3a8a'
              }}>
                Connect With Us
              </h2>
              <p style={{ 
                color: '#718096',
                marginBottom: '2rem',
                fontSize: '1.1rem'
              }}>
                Follow us on social media for the latest updates and community highlights
              </p>
              <div style={{ 
                display: 'flex',
                justifyContent: 'center',
                gap: '2rem',
                fontSize: '3rem'
              }}>
                <a 
                  href='https://www.instagram.com/p10rating/' 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{ 
                    color: '#E4405F',
                    transition: 'transform 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.2)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                >
                  <FaInstagram />
                </a>
                <a 
                  href='https://www.facebook.com/people/P10-Rating/100077345056598/?mibextid=LQQJ4d' 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{ 
                    color: '#1877F2',
                    transition: 'transform 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.2)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                >
                  <FaFacebookSquare />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Navbar */}
        <Navbar fixed="bottom" style={{ 
          background: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)',
          boxShadow: '0 -2px 20px rgba(0,0,0,0.1)',
          padding: '1rem'
        }}>
          <Nav style={{ 
            width: '100%', 
            display: 'flex', 
            justifyContent: 'center',
            flexWrap: 'wrap',
            gap: '0.5rem'
          }}>
            <span style={{ margin: '0 0.5rem', color: '#4a5568', fontWeight: '500' }}>
              p10rating © 2026
            </span>
            <Link to='/privacypolicy' style={{ margin: '0 0.5rem', color: '#3b82f6', textDecoration: 'none', fontWeight: '500' }}>
              Privacy
            </Link>
            <Link to='/disclaimer' style={{ margin: '0 0.5rem', color: '#3b82f6', textDecoration: 'none', fontWeight: '500' }}>
              Disclaimer
            </Link>
            <Link to='/terms' style={{ margin: '0 0.5rem', color: '#3b82f6', textDecoration: 'none', fontWeight: '500' }}>
              Terms
            </Link>
            <Link to='/signin' style={{ margin: '0 0.5rem', color: '#3b82f6', textDecoration: 'none', fontWeight: '500' }}>
              Sign In
            </Link>
          </Nav>
        </Navbar>
      </div>
    );
  }
}

export default AboutPage;